import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/baixa`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        history: {
            datatable(queryParms = {}) {

                return repository.get(`${baseUrl}/history?${urlUtil.serialize(queryParms)}`)
            },
        },
        create(materialId) {

            return repository.get(`${baseUrl}/create/${materialId}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        reverse(saidaItemId) {

            return repository.put(`${baseUrl}/reverse/${saidaItemId}`)
        },
    }
}